import styled from '@emotion/styled/macro';

import FormMessage from '../../../../../../../styledComponents/UI/Form/FormMessage/FormMessage';
import FormValueInfo from '../../../../../../../styledComponents/UI/Form/FormValueInfo/FormValueInfo';

export const StyledFormMessage = styled(FormMessage)`
  margin-top: 0.5rem;
`;

export const StyledFormValueInfo = styled(FormValueInfo)`
  width: 9rem;
`;
